import request2 from '@/utils/request2'

function register(phone, passwd, code) {
    return request2({
        url: '/api/manager/register/code',
        method: 'post',
        data: {
            phone: phone,
            pwd: passwd,
            code: code,
        }
    })
}


function login(phone, passwd) {
    return request2({
        url: '/api/manager/validate/pwd',
        method: 'post',
        data: {
            phone: phone,
            pwd: passwd
        }
    })
}


function baseInfo(userId) {
    return request2({
        url: '/api/manager/info/'+userId,
        method: 'get'
    })
}




export default {
    register,
    login,
    baseInfo
}